import { defineService } from '@nzyme/ioc/Service.js';
import { AuthStore } from '../auth/AuthStore.js';
import { createBatchedCache } from '../utils/createBatchedCache.js';
import { FileMetadataLoader } from './FileMetadataLoader.js';
/**
 * Buffer subtracted from a signed-URL expiration before treating an entry as
 * expired — gives consumers headroom to use the URL before it actually rolls
 * over server-side.
 */
const EXPIRY_BUFFER_MS = 5 * 60 * 1000;
export const FileMetadataStore = defineService({
    name: 'FileMetadataStore',
    deps: {
        loader: FileMetadataLoader,
        authStore: AuthStore,
    },
    setup({ loader, authStore }) {
        const cache = createBatchedCache({
            fetchBatch: fileIds => loader(fileIds),
            matchParam: (file, fileId) => file.id === fileId,
            isExpired: (file, now) => {
                if (file.expiresAt === undefined) {
                    return false;
                }
                return now >= file.expiresAt - EXPIRY_BUFFER_MS;
            },
        });
        // Cached presigned URLs are scoped to the currently logged-in user —
        // wipe the cache on logout/account switch so a different user can't
        // observe URLs minted for the previous session.
        authStore.events.userChanged.on(() => cache.clear());
        return {
            get: fileId => cache.get(fileId),
            getCached: fileId => cache.getCached(fileId),
            set: (fileId, metadata) => cache.set(fileId, metadata),
            clear: () => cache.clear(),
            delete: fileId => cache.delete(fileId),
        };
    },
});
//# sourceMappingURL=FileMetadataStore.js.map